// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sjI4","clinicsSelect":"styles_clinicsSelect__1BMxG"};